import React from 'react';

const ProfileConfig = {
    routes: [
        {
            path: '/settings/profile',
            private: true,
            hasLayout: true,
            hasHeader: true,
            component: React.lazy(() => import('./ProfilePage')),
        },
    ],
};
export default ProfileConfig;
